<template lang="">
  <router-view />
</template>
<script>
export default {};
</script>
<style lang=""></style>
